﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
import './jquery';
import "jquery-mask-plugin";    
import "jquery-validation";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";
import { random, template } from "lodash";

export class TemplatesWidget {
    private element: HTMLElement;
    private service: Service;
    private debug: boolean = true;
    private statusBarWidget: StatusBarWidget;
    private Validator: JQueryValidation.Validator;

    private renderFormUrl = null;
    private submitDocumentsUrl = null;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;   
        this.init();

    }

    //can only be fired once
    init() {
        var th = this;
        this.element = $(".templates-widget")[0];
        this._debugging("init template");          

        $(this.element).find('[data-name=btnSubmitTemplateForm]').off("click");
        $(this.element).find('[data-name=btnSubmitTemplateForm]').on("click", (ev:Event)=> th.submitDocuments(ev));
        $(this.element).find('#templateSelect').off("change");
        $(this.element).find('#templateSelect').on("change", (ev: Event) => th.onSelectChange(ev));

        this.renderFormUrl = $(this.element).data("renderFormUrl");
        this.submitDocumentsUrl = $(this.element).data("submitDocumentsUrl");            
    }

    //function for initializing elements from partials loaded after the initial load
    initNoLoad() {
        var th = this;
        
    }

    //add podpisnkiki
    async onSelectChange(ev: Event) {
        ev.preventDefault();
        let el = $(this.element).find('.document-form-wrapper');
        let templateId = $(ev.currentTarget).find(":selected").val();
        let url = this.renderFormUrl +"?templateId="+templateId;
        await this.service.GetView(url, el, this.statusBarWidget);
        this.initNoLoad();
    }


    validateForm(id) {
        var valid = $(id).validate().checkForm();
    }
    //submit
    async submitDocuments(ev: Event) {
        try {
            ev.preventDefault();
            let th = this;
            this._debugging("submitting documents");
            let formElement = $(this.element).find("#form") as JQuery<HTMLFormElement>;
            this._debugging(formElement);

            //validation
            var valid = true;
            $(document).on('blur keyup change', 'form input', function (e) {
                var input = $(this),
                    form = input.closest('form');
                form.valid();
            });                     

            var formPartials = formElement.find("form");

            formPartials.each(function (i, e) {
                $(e).validate();
                $(e).find("[data-name=SignerEmail]").rules("add",
                {
                    required: true,
                    messages: {
                        required: "Epoštni naslov podpisnika je obvezen podatek."
                    }
                });

                $(e).find("[data-name=SignerTaxNum]").rules("add",
                {
                    obveznaEnaDavcna: true,
                    messages: {
                        required: "Obvezna je vsaj ena davčna številka."
                    }
                });

                $(e).find("[data-name=SignerCompanyTaxNum]").rules("add",
                {
                    obveznaEnaDavcna: true,
                    messages: {
                        required: "Obvezna je vsaj ena davčna številka."
                    }
                });
                

                if (!$(e).valid()) {
                    valid = false;
                }
            });


            //$("form").first().valid();
            if (!valid) {
                return false; 
            }
            
            
            let serializedData = [];
            formElement.find("form").each(function (i,e) {
                serializedData.push($(e).serializeArray());
            });
                
            
            this._debugging("valid");
            this._debugging("ready to post");

            let templateId = $(this.element).find("#templateSelect").find(":selected").val().toString();
            

            let el = $(".main-container");
            let url = this.submitDocumentsUrl;
            /*var formData = new FormData(formElement[0]);*/
            var formData = new FormData();
            formData.append(`request.id`, templateId);

            for (let i = 0; i < serializedData.length; i++) {
                let name = serializedData[i][0].value;
                let taxNumber = serializedData[i][1].value ?? "";
                let companyTaxNum = serializedData[i][2].value ?? "";
                this._debugging({ SignerEmail: name, SignerTaxNum: taxNumber, CompanyTaxNum: companyTaxNum });
                formData.append(`request.signers[${i}].signerEmail`, name);
                formData.append(`request.signers[${i}].signerTaxNum`, taxNumber);
                formData.append(`request.signers[${i}].signerCompanyTaxNum`, companyTaxNum);
            }

            this._showLoader();
            $("#signature-modal").modal('hide');;
            await this.service.PostFile(formData, el, url, this.statusBarWidget);
            this.statusBarWidget.setStatus("Uspešno ustvarjen zahtevek.", "ok");
            this.init();
            this._hideLoader();
            this._debugging("posted");
        }
        catch (ex: any) {
            let err = decodeURIComponent(atob(ex.getResponseHeader("err")).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            this.statusBarWidget.setStatus(err ?? "Error", "bad");
            this._hideLoader();
        }
    }

    _scrollToTop() {
        window.scroll({ top: 0, left: 0 });
    }

    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element, 300);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
    refreshCSS = () => {
        let links = document.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            if (links[i].getAttribute('rel') == 'stylesheet') {
                let href = links[i].getAttribute('href')
                    .split('?')[0];

                let newHref = href + '?version='
                    + new Date().getMilliseconds();

                links[i].setAttribute('href', newHref);
            }
        }
    }            
}

